var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "go-block-footer" }, [
    _c(
      "div",
      { staticClass: "go-card-info" },
      [
        _vm.formModel.type === "REPORT" ||
        _vm.formModel.type === "TOPIC_SUMMARY"
          ? [
              _vm.formModel.userProfile
                ? _c(
                    "a",
                    {
                      staticClass: "go-info-item go-user-info",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.selectUserSocial.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "go-user-thumb" }, [
                        _c("img", {
                          attrs: { src: _vm.formModel.userProfile.imageUrl },
                          on: { error: _vm.onErrorImageAvatar },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              value: { customClass: "go-tooltip" },
                              expression: "{ customClass: 'go-tooltip' }",
                              modifiers: { hover: true },
                            },
                          ],
                          staticClass: "go-user-id truncate",
                          attrs: { title: _vm.formModel.userProfile.lastName },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.formModel.userProfile.lastName) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.moment(_vm.formModel.publishAt, "YYYYMMDDHHmmss").isValid()
          ? _c("span", { staticClass: "go-info-item go-datetime truncate" }, [
              _c("em", { staticClass: "go-text" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.formatDateAgo(
                        _vm.moment.utc(
                          _vm.formModel.publishAt,
                          "YYYYMMDDHHmmss"
                        )
                      )
                    ) +
                    "\n      "
                ),
              ]),
            ])
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "go-btn-area" }, [
      !_vm.isHideOptions
        ? _c("div", { staticClass: "dropdown" }, [
            _c(
              "button",
              {
                staticClass: "btn go-btn-icon",
                attrs: {
                  id: "dropDownDiscoveryButton" + _vm.formModel.docId,
                  type: "button",
                  "data-toggle": "dropdown",
                  "aria-expanded": "false",
                },
              },
              [_c("i", { staticClass: "go-icon-20 go-icon-more-dot" })]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "dropdown-menu dropdown-menu-right" }, [
              !_vm.isHideGoover
                ? _c(
                    "a",
                    { staticClass: "dropdown-item", on: { click: _vm.goover } },
                    [
                      _c("i", { staticClass: "go-icon-18 go-icon-goover" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "go-text" }, [
                        _vm._v("Go Over"),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isHideAddReference
                ? _c(
                    "button",
                    {
                      staticClass: "dropdown-item",
                      attrs: {
                        type: "button",
                        disabled: _vm.getReferenceDocuments.some(function (
                          document
                        ) {
                          return (
                            document.path === _vm.formModel.url ||
                            document.parentDocId === _vm.formModel.docId
                          )
                        }),
                      },
                      on: { click: _vm.addToReference },
                    },
                    [
                      _c("i", {
                        staticClass: "go-icon-20 go-icon-chat-reference-add",
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "go-text" }, [
                        _vm._v(_vm._s(_vm.$t("briefing.label.reference"))),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  on: { click: _vm.toggleResource },
                },
                [
                  _vm.formModel.isBookmarked
                    ? _c("i", { staticClass: "go-icon-18 go-icon-bookmark-on" })
                    : _c("i", {
                        staticClass: "go-icon-18 go-icon-bookmark-line",
                      }),
                  _vm._v(" "),
                  _c("span", { staticClass: "go-text" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "briefing.label." +
                            (_vm.formModel.isBookmarked
                              ? "remove-to-scrape"
                              : "add-to-scrape")
                        )
                      )
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  attrs: { "data-target": "#go-modal-pin-limit" },
                  on: { click: _vm.share },
                },
                [
                  _c("i", { staticClass: "go-icon-20 go-icon-share" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "go-text" }, [
                    _vm._v(_vm._s(_vm.$t("common.label.share"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.formModel.channel === "Podcast Goover"
                ? _c(
                    "a",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function ($event) {
                          return _vm.downloadPodcast(
                            _vm.formModel.url,
                            _vm.formModel.title
                          )
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "go-icon-20 go-icon-download" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "go-text" }, [
                        _vm._v(_vm._s(_vm.$t("my-create.podcast.download"))),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isHideHidden
                ? _c(
                    "a",
                    { staticClass: "dropdown-item", on: { click: _vm.hide } },
                    [
                      _vm.userKey === _vm.formModel.owner_user_key
                        ? [
                            _c("i", {
                              staticClass: "go-icon-20 go-icon-trash",
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "go-text" }, [
                              _vm._v(_vm._s(_vm.$t("common.label.delete"))),
                            ]),
                          ]
                        : [
                            _c("i", {
                              staticClass: "go-icon-20 go-icon-hidden",
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "go-text" }, [
                              _vm._v(_vm._s(_vm.$t("common.label.hide"))),
                            ]),
                          ],
                    ],
                    2
                  )
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }